import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'; 
import { Observable } from 'rxjs';

@Injectable()
export class LocalDataService {


    constructor(private http: HttpClient) {
        
    }

    public getJSON(fileName): Observable<any> {
        return this.http.get("./assets/static-data/" + fileName)
    }
}